import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
    name: "SiteNavigationOverlay",
    setup(){
        const store = useStore()
        const showOverlay = computed(()=>store.state.main.overlay_visible)
        const callbackOnRemove = computed(()=>store.state.main.overlay_callback_on_remove)
        

        return {
            showOverlay,
            callbackOnRemove
        }
    }
}